// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFileMarkdownOutlinedSvg from "@fishx/icons-svg/es/asn/PFileMarkdownOutlined";
import FishxIcon from '../components/FishxIcon';

var PFileMarkdownOutlined = function PFileMarkdownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFileMarkdownOutlinedSvg
  }));
};

PFileMarkdownOutlined.displayName = 'PFileMarkdownOutlined';
export default React.forwardRef(PFileMarkdownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFileMarkdownOutlined.js
// module id = 3394
// module chunks = 0